import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dotnet-dev',
  templateUrl: './dotnet-dev.component.html',
  styleUrls: ['./dotnet-dev.component.css']
})
export class DotnetDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/dotnet-dev/dotnet-dev.component.ts